import React from "react";
import Sidebar from "./Sidebar";
import { Link, Outlet } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";

function DashboardLayout() {
  return (
    <>
       <Breadcrump title="My Account" />

      <div className="flat-spacing-13">
        <div className="container">
          {/* <div className="btn-sidebar-mb d-lg-none">
            <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount">
              <i className="icon icon-sidebar" />
            </button>
          </div> */}
          <div className="main-content-account">
            <Sidebar />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
